export type NavItem = { label: string; href: string; description?: string };

export const serviceMenu: readonly NavItem[] = [
  { label: "Consulting", href: "/consulting", description: "AI leadership, websites with AI, custom builds" },
  { label: "DevOps contracts", href: "/hire", description: "Cloud costs, CI, migrations, app rescue" },
  { label: "Local websites", href: "/local", description: "Booking sites, business sites, Shopify stores" },
] as const;

export const serviceExtras: readonly NavItem[] = [
  { label: "Security scan", href: "/scan", description: "A quick check for AI-built apps" },
  { label: "60-minute consult", href: "/consult", description: "A paid hour on your stack" },
] as const;

export const headerLinks: readonly NavItem[] = [
  { label: "Products", href: "/products" },
  { label: "Resume", href: "/resume" },
] as const;

export const contactNav = { label: "Contact", href: "/contact" } as const;

export function pathIsActive(pathname: string, href: string) {
  if (href === "/") return pathname === "/";
  return pathname === href || pathname.startsWith(`${href}/`);
}

export function servicesMenuIsActive(pathname: string) {
  return [...serviceMenu, ...serviceExtras].some((item) => pathIsActive(pathname, item.href));
}
